import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { AppShell } from './ui';

/**
 * MainLayout — wraps every public route in the new AppShell.
 * The single source of truth for navigation. Used by App.js.
 */
const MainLayout = ({ children, showTopBar = true }) => (
  <AppShell showTopBar={showTopBar}>
    <Suspense fallback={<div className="gm-route-loading" aria-hidden="true" />}>
      {children || <Outlet />}
    </Suspense>
  </AppShell>
);

MainLayout.propTypes = {
  children: PropTypes.node,
  showTopBar: PropTypes.bool,
};

export default MainLayout;
